import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { DiscountNavigationService } from '../services/discount-navigation.service';

@Injectable({
  providedIn: 'root',
})
export class DiscountNavigationGuard {
  private discountNavigationService = inject(DiscountNavigationService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  canActivate(): Observable<boolean> {
    return this.discountNavigationService.canNavigate();
  }
}
